import styled, { css } from 'styled-components';
import Typography from '../typography/Typography';
export const BUTTON_STYLES = {
    primary: css `
    background-color: ${({ theme }) => theme.colors.interactive.brandColor};
    color: ${({ theme }) => theme.colors.text.interactive};
    &:active {
      box-shadow: 0 0 1rem ${({ theme }) => theme.colors.borders.hover};
    }
    ${({ theme }) => {
        const backgroundColor = theme.colors.interactive.brandColorHover;
        return theme.media.laptop `
        &:hover {
          background-color: ${backgroundColor}
        }
      `;
    }}
    &:disabled {
      cursor: not-allowed;
      color: ${({ theme }) => theme.colors.text.interactive};
      /* background-color: ${({ theme }) => theme.colors.interactive.brandColorDisabled}; */
      opacity: 0.2;
      box-shadow: none;
    }
  `,
    secondary: css `
    background-color: ${({ theme }) => theme.colors.surface.default};
    color: ${({ theme }) => theme.colors.text.default};
    border: 1px solid ${({ theme }) => theme.colors.borders.default};
    &:active {
      box-shadow: 0 0 1rem ${({ theme }) => theme.colors.borders.hover};
    }
    ${({ theme }) => {
        const backgroundColor = theme.colors.surface.interactiveDefault;
        return theme.media.laptop `
        &:hover {
          background-color: ${backgroundColor}
        }
      `;
    }}
    &:disabled {
      cursor: not-allowed;
      color: ${({ theme }) => theme.colors.text.disabled};
      border-color: ${({ theme }) => theme.colors.borders.disabled};
      /* background-color: ${({ theme }) => theme.colors.surface.default}; */
      opacity: 0.2;
      box-shadow: none;
    }
  `,
    combined: css `
    color: ${({ theme }) => theme.colors.text.default};
    border: 1px solid ${({ theme }) => theme.colors.borders.highlight};
    background-color: ${({ theme }) => theme.colors.interactive.secondary};
    &:active {
      box-shadow: 0 0 1rem ${({ theme }) => theme.colors.borders.hover};
    }
    ${({ theme }) => theme.media.laptop `
      &:hover {
        opacity: 0.85;
        transition: opacity 0.3s ease-in-out;
      }
    `}
    &:disabled {
      cursor: not-allowed;
      color: ${({ theme }) => theme.colors.interactive.brandColorDisabled};
      border-color: ${({ theme }) => theme.colors.interactive.brandColorDisabled};
      /* background-color: ${({ theme }) => theme.colors.interactive.secondaryDisabled}; */
      opacity: 0.2;
      box-shadow: none;
    }
  `,
    tertiary: css `
    background-color: ${({ theme }) => theme.colors.surface.default};
    border: none;
    color: ${({ theme }) => theme.colors.text.default};
    &:active {
      box-shadow: 0 0 1rem ${({ theme }) => theme.colors.borders.hover};
    }
    ${({ theme }) => {
        const backgroundColor = theme.colors.surface.interactiveDefault;
        return theme.media.laptop `
        &:hover {
          background-color: ${backgroundColor}
        }
      `;
    }}
    &:disabled {
      cursor: not-allowed;
      color: ${({ theme }) => theme.colors.text.disabled};
      /* background-color: ${({ theme }) => theme.colors.surface.default}; */
      opacity: 0.2;
      box-shadow: none;
    }
  `,
};
export const LottieWrapper = styled.div `
  width: 5rem;
  height: 5rem;
`;
export const BUTTON_SIZE = {
    sm: css `
    height: 4rem;
    border-radius: ${({ theme }) => theme.borderRadius.highL};
  `,
    md: css `
    height: 4.8rem;
    border-radius: ${({ theme }) => theme.borderRadius.high};
  `,
    lg: css `
    height: 6rem;
    border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  `,
};
export const CustomButton = styled.button `
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-out;

  width: 100%;

  border: none;
  ${({ buttonType }) => BUTTON_STYLES[buttonType]}
  ${({ size }) => (size ? BUTTON_SIZE[size] : '')}

  ${({ destructive, theme }) => destructive &&
    `
    background-color: ${theme.colors.interactive.critical};
    color:${theme.colors.surface.default};
    border:none;
    &:hover{
      background-color: ${theme.colors.interactive.criticalHover};
      
    }

    &:active{
      box-shadow: 0 0 1rem ${theme.colors.borders.hover};
    }

    &:disabled {
      cursor: not-allowed;
      color: ${theme.colors.surface.default};
      background-color: ${theme.colors.interactive.criticalDisabled};
      box-shadow: ${theme.shadows.xs};
    }
  `}

  font-size: ${({ fontSize }) => fontSize || '1.6rem'};
  font-family: ${({ theme }) => theme.fonts.primaryBold};

  cursor: pointer;
`;
export const ButtonText = styled(Typography) `
  color: inherit;

  ${({ iconPosition, hasIcon }) => {
    if (!hasIcon)
        return;
    return iconPosition === 'left'
        ? `margin-left: 0.8rem;`
        : 'margin-right: 0.8rem;';
}};

  ${({ titleColor }) => titleColor && `color: ${titleColor}`}
`;
export const IconWraper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const IconImg = styled.img `
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  width: 2rem;
  height: 2rem;
`;
// DOWNLOAD BUTTON
export const ReceiptButton = styled.a `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  min-height: 6.2rem;

  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.interactive.brandColor};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
`;
export const IconWrapper = styled.div `
  width: 3.7rem;
  height: 3.7rem;
  margin-right: 1rem;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
`;
//# sourceMappingURL=styles.js.map